import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Grid,
  TextField,
  Button,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import dayjs from "dayjs";
import SelectBox from "../../components/commonComponents/SelectBox/SelectBox";
import axios from "axios";
import {
  activateSimsWithWhitelisting,
  fetchPlansAndGroupByAccount,
  updateSimStates,
  TopUP,
  KycOperation,
} from "../DeviceManagement/Utility";
import { userPermissions } from "../customerManagement/utility/authUtils";
import WhitelistPopup from "../../components/commonComponents/POPUP/WhitelistPopup";
import PlanDetailsPopup from "../../components/commonComponents/POPUP/PlanDetailsPopup";
import DeviceTypePopup from "../../components/commonComponents/POPUP/DeviceTypePopup";
import Topup from "../../components/commonComponents/POPUP/Topup";
import { Api } from "@mui/icons-material";
import KYC_PopUp from "../../components/commonComponents/POPUP/KYC_PopUp";
import AllocatePopup from "../../components/commonComponents/POPUP/AllocatePopup";
import Renewal from "../../components/commonComponents/POPUP/Renewal";
import { BASE_URL } from "../../config";
import api from "../../components/commonComponents/axiosSetup";

const RangeActionFilter = ({
  data,
  availableFields,
  availableActions,
  actionTargetField,
  onFilteredDataChange,
  onApplyAction,
  dateFormat = "DD/MM/YYYY",
  onReset,
}) => {
  const [selectedField, setSelectedField] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [actionId, setActionId] = useState(availableActions[0]?.value || "");
  const [deviceTypeValue, setDeviceTypeValue] = useState("");
  const [kycPopUp, setKycPopup] = useState(false);
  const [accountDetails, setAccountDetails] = useState({});
  const [selectedPlans, setSelectedPlans] = useState({});
  const [currentFilteredData, setCurrentFilteredData] = useState([]);
  const [showDeviceTypePopup, setShowDeviceTypePopup] = useState(false);
  const [tempDeviceTypeValue, setTempDeviceTypeValue] = useState("");
  const [showTopup, setShowTopup] = useState(false);
  const [showWhitelistPopup, setShowWhitelistPopup] = useState(false);
  const [tempWhitelistIpGroup, setTempWhitelistIpGroup] = useState("");
  const [tempWhitelistNumberGroup, setTempWhitelistNumberGroup] = useState("");
  const [dataWhitelistData, setDataWhitelistData] = useState([]);
  const [dataWhitelistOptions, setDataWhitelistOptions] = useState([]);
  const [loadingDataWhitelistOptions, setLoadingDataWhitelistOptions] =
    useState(false);
  const [smsWhitelistData, setSmsWhitelistData] = useState([]);
  const [smsWhitelistOptions, setSmsWhitelistOptions] = useState([]);
  const [loadingSmsWhitelistOptions, setLoadingSmsWhitelistOptions] =
    useState(false);
  const [isActivationChecked] = useState(true);
  const [isKycChecked, setIsKycChecked] = useState(false);
  const [deviceModelValue, setDeviceModelValue] = useState("");
  const [tempDeviceModelValue, setTempDeviceModelValue] = useState("");
  const [kycForm, setKycForm] = useState({
    msisdn: "",
    iccid: "",
    deviceImei: "",
    deviceType: "",
    deviceModel: "",
    deviceSerialNumber: "",
    deviceMake: "",
    engineNumber: "",
    chasisNumber: "",
    registeredMobileNumber: "",
    registrationNo: "",
    custodianName: "",
    custodianAddress: "",
    addressDocumentType: "",
    addressDocumentNumber: "",
    identityDocumentType: "",
    identityDocumentNumber: "",
    devicetypeother: "",
  });
  const [allocateToValue, setAllocateToValue] = useState("");
  const [tempAllocateToValue, setTempAllocateToValue] = useState("");
  const [showAllocatePopup, setShowAllocatePopup] = useState(false);
  const [showRenewal, setShowRenewal] = useState(false);

  const [isWhitelistIpChecked, setIsWhitelistIpChecked] = useState(false);
  const [isWhitelistNumberChecked, setIsWhitelistNumberChecked] =
    useState(false);
  const getDataRequestIdByName = (selectedName) => {
    if (!selectedName) return null;
    const foundItem = dataWhitelistData.find(
      (item) => item.name === selectedName,
    );
    return foundItem ? foundItem.requestId : null;
  };

  const handleCloseAllocatePopup = () => {
    setShowAllocatePopup(false);
    setTempAllocateToValue("");
    if (!allocateToValue) {
      setActionId(availableActions[0]?.value || "");
    }
  };
  const handleConfirmAllocate = async () => {
    const newAllocateTo = tempAllocateToValue.trim();

    setAllocateToValue(newAllocateTo);
    setShowAllocatePopup(false);
    setTempAllocateToValue("");

    const filteredCheckedItems = currentFilteredData.filter(
      (item) => item.checked,
    );

    if (filteredCheckedItems.length === 0) {
      alert("No items selected in this range to apply the action.");
      return;
    }

    const firstVendor = filteredCheckedItems[0].vendor;
    const allSameVendor = filteredCheckedItems.every(
      (item) => item.vendor === firstVendor,
    );

    if (!allSameVendor) {
      alert("Selected items must have the same Operator to apply this action.");
      return;
    }

    try {
      const updated = filteredCheckedItems.map((item) => {
        const updatedItem = { ...item };
        if (newAllocateTo) updatedItem.allocatedTo = newAllocateTo;
        // if (newDeviceModel) updatedItem.deviceModel = newDeviceModel;
        return updatedItem;
      });

      const allocateUpdatePayload = updated.map((item) => ({
        iccid: item.iccid,
        allocatedTo: newAllocateTo,
      }));

      await updateSimStates(allocateUpdatePayload);

      onApplyAction(updated);

      alert(
        `SIM(s) allocated to "${newAllocateTo}" for ${filteredCheckedItems.length} selected items.`,
      );
      handleReset();
    } catch (error) {
      console.error("Allocation update failed", error);
      alert("Something went wrong while allocating SIM(s).");
    }
  };

  const handleOpenKycPopup = () => {
    const checkedItems = currentFilteredData.filter((item) => item.checked);

    if (checkedItems.length === 0) {
      alert("Please select a SIM to update KYC.");
      setActionId(availableActions[0]?.value || "");
      return;
    } else if (checkedItems.length > 1) {
      alert(
        "Please select only one SIM to update KYC at a time. If you want to do KYC in bulk please refer to Bulk operation",
      );
      setActionId(availableActions[0]?.value || "");
      return;
    }

    const checkedItem = checkedItems[0];

    setKycForm((prev) => ({
      ...prev,
      msisdn: checkedItem.msisdn,
      deviceImei: checkedItem.deviceId,
      deviceType: checkedItem.deviceType,
      iccid: checkedItem.iccid,
    }));

    if (
      checkedItem.simState?.toUpperCase() === "SUSPENDED" ||
      checkedItem.simState?.toUpperCase() === "TERMINATED"
    ) {
      alert(
        "KYC cannot be performed on SUSPENDED or TERMINATED SIMs. Please select a different SIM.",
      );
      setActionId(availableActions[0]?.value || "");
    } else if (checkedItem.simState?.toUpperCase() === "AVAILABLE") {
      alert(
        "KYC cannot be performed on AVAILABLE SIMs. Please activate the SIM first.",
      );
      setActionId(availableActions[0]?.value || "");
    } else {
      setKycPopup(true);
    }
  };

  const getSmsRequestIdByName = (selectedName) => {
    if (!selectedName) return null;
    const foundItem = smsWhitelistData.find(
      (item) => item.name === selectedName,
    );
    return foundItem ? foundItem.requestId : null;
  };
  const fetchDataWhitelistOptions = async () => {
    setLoadingDataWhitelistOptions(true);
    try {
      const response = await api.get(
        `${BASE_URL}api/airtel/data/whitelist/list/groupnames`,
      );

      if (response.data && Array.isArray(response.data)) {
        setDataWhitelistData(response.data);
        const options = response.data
          .map((item) => item.name)
          .filter((name) => name && name.trim() !== "");
        console.log("Fetched data whitelist options:", options);

        setDataWhitelistOptions(options);
      }
    } catch (error) {
      console.error("Failed to fetch data whitelist options:", error);
      setDataWhitelistData([]);
      setDataWhitelistOptions([]);
    } finally {
      setLoadingDataWhitelistOptions(false);
    }
  };

  const fetchSmsWhitelistOptions = async () => {
    setLoadingSmsWhitelistOptions(true);
    try {
      const response = await api.get(`${BASE_URL}api/sms/whitelist/get`);

      if (response.data && Array.isArray(response.data)) {
        setSmsWhitelistData(response.data);
        const options = response.data
          .map((item) => item.name)
          .filter((name) => name && name.trim() !== "");
        console.log("Fetched SMS whitelist options:", options);
        setSmsWhitelistOptions(options);
      }
    } catch (error) {
      console.error("Failed to fetch SMS whitelist options:", error);
      setSmsWhitelistData([]);
      setSmsWhitelistOptions([]);
    } finally {
      setLoadingSmsWhitelistOptions(false);
    }
  };
  // useEffect(() => {
  //   // fetchDataWhitelistOptions();
  //   fetchSmsWhitelistOptions();
  // }, []);
  const handlePlanToggle = (account, planType) => {
    setSelectedPlans((prev) => {
      const current = prev[account];
      return {
        ...prev,
        [account]: current === planType ? null : planType,
      };
    });
  };
  const fetchPlanDetails = async () => {
    const groupedPlans = await fetchPlansAndGroupByAccount(13);
    setAccountDetails(groupedPlans);
  };
  useEffect(() => {
    fetchPlanDetails();
  }, []);
  useEffect(() => {
    if (availableFields && availableFields.length > 0) {
      if (!selectedField) setSelectedField(availableFields[0]?.value || "");
    }
    if (availableActions && availableActions.length > 0) {
      if (!actionId) setActionId(availableActions[0]?.value || "");
    }
  }, [availableFields, selectedField, availableActions, actionId]);

  useEffect(() => {
    setCurrentFilteredData(data);
  }, [data]);
  const selectedFieldConfig = availableFields.find(
    (field) => field.value === selectedField,
  );

  const filterDataByRange = useCallback(
    (currentData, fieldConfig, fromValue, toValue) => {
      if (!fieldConfig || !fieldConfig.value) return currentData;
      const fieldName = fieldConfig.value;
      const fieldType = fieldConfig.type;
      return currentData.filter((item) => {
        const valueToCheck = item[fieldName];
        let passesRangeCheck = true;
        if (valueToCheck === null || valueToCheck === undefined) {
          if (fromValue || toValue) {
            return false;
          }
          return true;
        }
        if (fieldType === "date") {
          const itemDate = dayjs(valueToCheck, dateFormat);
          const fromDate = dayjs(fromValue, "YYYY-MM-DD");
          const toDate = dayjs(toValue, "YYYY-MM-DD");

          if (!itemDate.isValid()) return false;

          if (fromValue && itemDate.isBefore(fromDate.startOf("day"))) {
            passesRangeCheck = false;
          }

          if (toValue && itemDate.isAfter(toDate.endOf("day"))) {
            passesRangeCheck = false;
          }
        } else if (fieldType === "number") {
          const numValue = parseFloat(valueToCheck);
          if (isNaN(numValue)) return false;

          if (fromValue !== "" && numValue < parseFloat(fromValue)) {
            passesRangeCheck = false;
          }
          if (toValue !== "" && numValue > parseFloat(toValue)) {
            passesRangeCheck = false;
          }
        } else {
          const stringValue = String(valueToCheck);
          if (fromValue !== "" && stringValue < String(fromValue)) {
            passesRangeCheck = false;
          }
          if (toValue !== "" && stringValue > String(toValue)) {
            passesRangeCheck = false;
          }
        }

        return passesRangeCheck;
      });
    },
    [dateFormat],
  );

  const handleSearch = () => {
    const filteredData = filterDataByRange(data, selectedFieldConfig, from, to);
    setCurrentFilteredData(filteredData);
    onFilteredDataChange(filteredData);
  };

  const [showPlanDetailsPopup, setShowPlanDetailsPopup] = React.useState(false);
  const [groupedItemsToActivate, setGroupedItemsToActivate] = React.useState(
    {},
  );
  const handlePlanPopup = () => {
    const checkedItem = currentFilteredData.find((item) => item.checked);
    if (!checkedItem) {
      alert("Please select a SIM to update KYC.");
      return;
    }

    setKycForm((prev) => ({
      ...prev,
      msisdn: checkedItem.msisdn,
      deviceImei: checkedItem.deviceId,
      deviceType: checkedItem.deviceType,
    }));
  };

  const handleCloseDeviceTypePopup = () => {
    setShowDeviceTypePopup(false);
    setTempDeviceTypeValue("");
    setTempDeviceModelValue("");
    if (!deviceTypeValue && !deviceModelValue) {
      setActionId(availableActions[0]?.value || "");
    }
  };

  const handleConfirmDeviceType = async () => {
    const newDeviceType = tempDeviceTypeValue;
    const newDeviceModel = tempDeviceModelValue;

    setDeviceTypeValue(newDeviceType);
    setDeviceModelValue(newDeviceModel);
    setShowDeviceTypePopup(false);
    setTempDeviceTypeValue("");
    setTempDeviceModelValue("");

    const filteredCheckedItems = currentFilteredData.filter(
      (item) => item.checked,
    );

    if (filteredCheckedItems.length === 0) {
      alert("No items selected in this range to apply the action.");
      return;
    }

    const firstVendor = filteredCheckedItems[0].vendor;
    const allSameVendor = filteredCheckedItems.every(
      (item) => item.vendor === firstVendor,
    );

    if (!allSameVendor) {
      alert("Selected items must have the same Operator to apply this action.");
      return;
    }

    try {
      const updated = filteredCheckedItems.map((item) => {
        const updatedItem = { ...item };
        if (newDeviceType) updatedItem.deviceType = newDeviceType;
        if (newDeviceModel) updatedItem.deviceModel = newDeviceModel;
        return updatedItem;
      });

      const deviceTypeUpdatePayload = updated.map((item) => {
        const payload = { iccid: item.iccid };
        if (newDeviceType) payload.deviceType = newDeviceType;
        if (newDeviceModel) payload.deviceModel = newDeviceModel;
        return payload;
      });

      await updateSimStates(deviceTypeUpdatePayload);

      onApplyAction(updated);

      const updateMessage = [];
      if (newDeviceType) updateMessage.push(`Device type: "${newDeviceType}"`);
      if (newDeviceModel)
        updateMessage.push(`Device model: "${newDeviceModel}"`);

      alert(
        `Updated ${updateMessage.join(" and ")} for ${filteredCheckedItems.length} selected items.`,
      );
      handleReset();
    } catch (error) {
      console.error("Device type/model update failed", error);
      alert("Something went wrong while updating device type/model.");
    }
  };

  const handleCloseWhitelistPopup = () => {
    setShowWhitelistPopup(false);
    setTempWhitelistIpGroup("");
    setTempWhitelistNumberGroup("");
    setKycPopup(false);
    setActionId(availableActions[0]?.value || "");
  };

  const closekyc = () => {
    setKycPopup(false);
    setActionId(availableActions[0]?.value || "");
  };

  const handleConfirmWhitelist = async () => {
    const filteredCheckedItems = currentFilteredData.filter(
      (item) => item.checked,
    );

    if (filteredCheckedItems.length === 0) {
      alert("No items selected in this range to apply the action.");
      return;
    }

    const activeItems = filteredCheckedItems.filter(
      (item) => item.simState?.toLowerCase() === "active",
    );

    if (activeItems.length === 0) {
      alert(
        "No active SIMs selected. Please select active SIMs to apply the whitelist.",
      );
      return;
    }

    if (!tempWhitelistIpGroup && !tempWhitelistNumberGroup) {
      alert(
        "Please enter at least one whitelist value (IP Group or Number Group).",
      );
      return;
    }

    try {
      const operationType =
        isWhitelistIpChecked && isWhitelistNumberChecked
          ? "DATA+SMS"
          : isWhitelistIpChecked
            ? "Data_Whitelisting"
            : isWhitelistNumberChecked
              ? "SMS_Whitelisting"
              : "ACTIVATE";

      const whitelistUpdatePayload = activeItems.map((item) => {
        // ✅ Determine boolean flags
        const activation =
          !isWhitelistIpChecked && !isWhitelistNumberChecked ? true : false;
        const dataWhitelisting =
          tempWhitelistIpGroup === "SOURC1234"
            ? false
            : isWhitelistIpChecked
              ? true
              : false;
        const smsWhitelisting = isWhitelistNumberChecked ? true : false;

        const payload = {
          msisdn: item.msisdn,
          profile: item.vendor,
          simState: item.simState,
          planId: item.planId,
          validUpto: "",
          operation: operationType,
          deviceId: item.deviceId,
          iccid: item.iccid,
          euiccId: item.euiccid,

          // ✅ New keys added
          activation,
          dataWhitelisting,
          smsWhitelisting,
        };

        // Attach whitelist IDs if provided
        if (tempWhitelistIpGroup || isWhitelistIpChecked) {
          const dataRequestId = getDataRequestIdByName(tempWhitelistIpGroup);
          if (dataRequestId) {
            payload.dataWhiteListRequestId = dataRequestId;
          }
        }

        if (tempWhitelistNumberGroup || isWhitelistNumberChecked) {
          const smsRequestId = getSmsRequestIdByName(tempWhitelistNumberGroup);
          if (smsRequestId) {
            payload.smsWhiteListRequestId = smsRequestId;
          }
        }

        return payload;
      });

      console.log("Whitelist update payload:", whitelistUpdatePayload);

      const res = await activateSimsWithWhitelisting(whitelistUpdatePayload);
      console.log("API response:", res);

      let message = `Your Request has been processed successfully.`;

      if (Array.isArray(res) && Array.isArray(res[0])) {
        const messages = res[0].map((item) => {
          const mainMsg = item.message || "No message";
          const statusMsg =
            item.airtelResponse?.data?.statusMessage || "No status message";
          return `${mainMsg}: ${statusMsg}`;
        });
        message = messages.join("\n");
      }

      alert(message);

      const updated = filteredCheckedItems.map((item) => {
        if (item.simState?.toLowerCase() === "active") {
          return {
            ...item,
            whitelistIpGroup: tempWhitelistIpGroup || item.whitelistIpGroup,
            whitelistNumberGroup:
              tempWhitelistNumberGroup || item.whitelistNumberGroup,
          };
        }
        return item;
      });

      onApplyAction(updated);

      setShowWhitelistPopup(false);
      setTempWhitelistIpGroup("");
      setTempWhitelistNumberGroup("");
      handleReset();
    } catch (error) {
      console.error("Whitelist update failed", error);
      alert("Something went wrong while updating whitelist settings.");
    }
  };

  const handleconfirmkyc = async () => {
    try {
      const filteredCheckedItems = currentFilteredData.filter(
        (item) => item.checked,
      );

      if (filteredCheckedItems.length === 0) {
        alert("No items selected in this range to apply the action.");
        return;
      }
      const eligibleItems = filteredCheckedItems.filter(
        (item) =>
          item.simState?.toUpperCase() !== "SUSPENDED" &&
          item.simState?.toUpperCase() !== "TERMINATED",
      );

      if (eligibleItems.length === 0) {
        alert(
          "All selected SIM(s) are either SUSPENDED or TERMINATED. KYC cannot be performed.",
        );
        return;
      }

      const kycpayload = eligibleItems.map((item) => ({
        msisdn: item.msisdn,
        profile: item.vendor,
        simState: item.simState,
        planId: item.planId,
        validUpto: "",
        operation: "KYC",
        iccid: item.iccid,
        euiccId: item.euiccid,
        deviceImei: String(kycForm.deviceImei),
        deviceType: kycForm.deviceType,
        deviceModel: kycForm.deviceModel,
        custodianName: kycForm.custodianName,
        registrationNo: kycForm.registrationNo,
        custodianAddress: kycForm.custodianAddress,
        deviceTypeOthers: kycForm.devicetypeother,
        deviceSerialNumber: kycForm.deviceSerialNumber,
        deviceMake: kycForm.deviceMake,
        engineNumber: kycForm.engineNumber,
        chasisNumber: kycForm.chasisNumber,
        registeredMobileNumber: kycForm.registeredMobileNumber,
        addressDocumentType: kycForm.addressDocumentType,
        addressDocumentNumber: kycForm.addressDocumentNumber,
        identityDocumentType: kycForm.identityDocumentType,
        identityDocumentNumber: kycForm.identityDocumentNumber,
      }));

      const res = await KycOperation(kycpayload);
      console.log("API response:", res);

      let message = `Your KYC request has been processed successfully.`;

      if (Array.isArray(res) && Array.isArray(res[0])) {
        const messages = res[0].map((item) => {
          const mainMsg = item.message || "No message";
          return `${mainMsg}`;
        });
        message = messages.join("\n");
      }

      alert(message);
    } catch (error) {
      console.error("Whitelist update failed", error);
      alert("Something went wrong while updating KYC settings.");
    }
  };

  const handleApplyAction = async () => {
    if (!selectedField || !actionId) {
      console.warn("RangeActionFilter: Please select a field and an action.");
      return;
    }

    if (!actionTargetField) {
      console.error(
        "RangeActionFilter: Configuration error - 'actionTargetField' is missing.",
      );
      return;
    }

    const filteredCheckedItems = currentFilteredData.filter(
      (item) => item.checked,
    );

    const selectedSims = Object.values(filteredCheckedItems).flat();
    const hasMixedTertiary =
      selectedSims.some((sim) => !!sim._tertiaryData) &&
      selectedSims.some((sim) => !sim._tertiaryData);


      if (hasMixedTertiary) {
        alert("Please select SIMs with the same profile type. Mixing dual and triple profile SIMs is not allowed.");
        return;
      }

    if (filteredCheckedItems.length === 0) {
      alert("No items selected in this range to apply the action.");
      return;
    }
    const terminatedItems = filteredCheckedItems.filter(
      (item) =>
        item.simState?.toLowerCase() === "suspended" ||
        item.simState?.toLowerCase() === "terminated",
    );

    if (terminatedItems.length > 0) {
      alert(
        "Cannot change terminated or suspended SIM state. Please unselect terminated or suspended  items and try again.",
      );
      return;
    }
    if (actionId.toLowerCase() === "available") {
      const activeItems = filteredCheckedItems.filter(
        (item) => item.simState?.toLowerCase() === "active",
      );

      if (activeItems.length > 0) {
        alert(
          "Cannot change active SIM state to available. Please unselect active items and try again.",
        );
        return;
      }
    }

    if (actionId === "change_device_type") {
      return;
    }

    if (actionId === "whitelist") {
      return;
    }
    if (actionId === "KYC") {
      setKycPopup(true);

      return;
    }
    if (actionId.toLowerCase() === "safecustody") {
      const nonActiveItems = filteredCheckedItems.filter(
        (item) => item.simState?.toLowerCase() !== "active",
      );
      
      if (nonActiveItems.length > 0) {
        alert(
          "Safecustody action can only be applied to Active SIMs. Please unselect non-active items and try again.",
        );
        return;
      }
    }
    if (actionId.toLowerCase() === "active") {
    const alreadyActiveItems = filteredCheckedItems.filter((item) => {
  const simState = item.simState?.toLowerCase() || "";

  return simState === "active" || simState === "safecustody";
});
      const toBeActivatedItems = filteredCheckedItems.filter((item) => {
  const simState = item.simState?.toLowerCase() || "";

  return simState !== "active" && simState !== "safecustody";
});

      if (alreadyActiveItems.length > 0) {
        alert(`${alreadyActiveItems.length} item(s) already active`);
      }

      if (toBeActivatedItems.length > 0) {
        const grouped = toBeActivatedItems.reduce((acc, item) => {
          const accountName = item.account || "Unknown Account";
          if (!acc[accountName]) {
            acc[accountName] = [];
          }
          acc[accountName].push(item);
          return acc;
        }, {});

        setGroupedItemsToActivate(grouped);
        setShowPlanDetailsPopup(true);
        handlePlanPopup();
      }
      return;
    }

    try {
      const updated = filteredCheckedItems.map((item) => ({
        ...item,
        [actionTargetField]: actionId,
      }));

      const simUpdatePayload = updated.map((item) => ({
        iccid: item.iccid,
        simState: item.simState,
      }));

      await updateSimStates(simUpdatePayload);

      onApplyAction(updated);
      alert(`Action applied to ${filteredCheckedItems.length} selected items.`);
    } catch (error) {
      alert("Something went wrong while updating SIM state.");
    }
  };
  const closeTopup = () => {
    setShowTopup(false);
    setActionId(availableActions[0]?.value || "");
  };
  const closeRenewal = () => {
    setShowRenewal(false);
    setActionId(availableActions[0]?.value || "");
  };
  const handleClosePlanDetailsPopup = async () => {
    debugger;
    let allItemsToUpdate = [];

    for (const accountName in groupedItemsToActivate) {
      const itemsInAccount = groupedItemsToActivate[accountName];
      const selectedPlanForAccount = selectedPlans[accountName];

      if (selectedPlanForAccount) {
        const selectedPlanDetails =
          accountDetails[accountName]?.[selectedPlanForAccount] || {};

        allItemsToUpdate = allItemsToUpdate.concat(
          itemsInAccount.map((item) => ({
            ...item,
            [actionTargetField]: actionId,
            simState: "Active",
            selectedPlan: selectedPlanForAccount,
            validity: selectedPlanDetails.Valid_Upto || "",
            planData: selectedPlanDetails.data || "",
            planSms: selectedPlanDetails.sms || "",
            planCost: selectedPlanDetails.cost || "",
            planId: selectedPlanDetails.id,
          })),
        );
      } else {
        allItemsToUpdate = allItemsToUpdate.concat(itemsInAccount);
      }
    }

    if (allItemsToUpdate.length === 0) {
      setShowPlanDetailsPopup(false);
      setGroupedItemsToActivate({});
      setSelectedPlans({});
      return;
    }

    const loadScript = (src) => {
      return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
      });
    };

    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js",
    );
    if (!res) {
      alert("Failed to load Razorpay SDK. Please check your connection.");
      return;
    }

    const totalAmount =
      allItemsToUpdate.reduce((acc, item) => {
        const cleanCost = parseInt(String(item.planCost).replace(/[^\d]/g, ""));
        return acc + (cleanCost || 0);
      }, 0) * 100;

    const options = {
      key: "rzp_test_1DP5mmOlF5G5ag",
      amount: totalAmount,
      currency: "INR",
      name: "Watsoo Express Pvt. Ltd.",
      description: "SIM Activation Payment",
      handler: async function (response) {
        alert("Payment Successful! ID: " + response.razorpay_payment_id);

        try {
          let operationType = "ACTIVATE";
          if (isWhitelistIpChecked && isWhitelistNumberChecked) {
            operationType = "ACTIVATE+DATA+SMS";
          } else if (isWhitelistIpChecked && !isWhitelistNumberChecked) {
            operationType = "ACTIVATE+DATA";
          } else if (!isWhitelistIpChecked && isWhitelistNumberChecked) {
            operationType = "ACTIVATE+SMS";
          }
          const simUpdatePayload = allItemsToUpdate.map((item) => {
            const payload = {
              msisdn: item.msisdn,
              profile: item.vendor,
              simState: item.simState,
              planId: item.planId,
              validUpto: item.validity,
              operation: operationType,
            };

            if (isWhitelistIpChecked && tempWhitelistIpGroup) {
              payload.dataWhiteList = tempWhitelistIpGroup;
              const dataRequestId =
                getDataRequestIdByName(tempWhitelistIpGroup);
              if (dataRequestId) {
                payload.dataWhiteListRequestId = dataRequestId;
              }
            }

            if (isWhitelistNumberChecked && tempWhitelistNumberGroup) {
              payload.smsWhiteList = tempWhitelistNumberGroup;
              const smsRequestId = getSmsRequestIdByName(
                tempWhitelistNumberGroup,
              );
              if (smsRequestId) {
                payload.smsWhiteListRequestId = smsRequestId;
              }
            }

            return payload;
          });

          console.log(
            "Activation payload with separate whitelist requestIds:",
            simUpdatePayload,
          );
          const res = await activateSimsWithWhitelisting(simUpdatePayload);
          console.log(res, "dfghjk");
          debugger;
          alert(res.message);
          console.log("API response:", res);
          console.log(
            "Used activateSimsWithWhitelisting API for activation with separate APIs",
          );
        } catch (error) {
          console.error("API update failed", error);
          alert("Something went wrong while updating SIM state.");
          return;
        }
        onApplyAction(allItemsToUpdate);
        setShowPlanDetailsPopup(false);
        setGroupedItemsToActivate({});
        setSelectedPlans({});
        setIsWhitelistIpChecked(false);
        setIsWhitelistNumberChecked(false);
        setTempWhitelistIpGroup("");
        setTempWhitelistNumberGroup("");
      },
      prefill: {
        name: "Customer Name",
        email: "example@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Watsoo Express Pvt. Ltd.",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };
  const handleReset = () => {
    setSelectedField(availableFields[0]?.value || "");
    setFrom("");
    setTo("");
    setActionId(availableActions[0]?.value || "");
    setDeviceTypeValue("");
    setDeviceModelValue("");
    setAllocateToValue("");
    setCurrentFilteredData(data);
    setIsWhitelistIpChecked(false);
    setIsWhitelistNumberChecked(false);
    setTempWhitelistIpGroup("");
    setTempWhitelistNumberGroup("");
    if (onReset) {
      onReset();
    }
  };

  const handleActionChange = (e) => {
    const value = e.target.value;
    setActionId(value);

    if (value === "change_device_type") {
      const checkedItem = currentFilteredData.find((item) => item.checked);
      if (!checkedItem) {
        alert("Please select a SIM to update Device Type.");
        setActionId(availableActions[0]?.value || "");
        return;
      }
      setTempDeviceTypeValue(deviceTypeValue);
      setTempDeviceModelValue(deviceModelValue);
      setShowDeviceTypePopup(true);
    } else if (value === "allocate") {
      const checkedItem = currentFilteredData.find((item) => item.checked);
      if (!checkedItem) {
        alert("Please select a SIM to allocate.");
        setActionId(availableActions[0]?.value || "");
        return;
      }
      setTempAllocateToValue(allocateToValue);
      setShowAllocatePopup(true);
    } else if (value === "whitelist") {
      const checkedItems = currentFilteredData.filter((item) => item.checked);

      // ✅ 1. No SIMs selected
      if (checkedItems.length === 0) {
        alert("Please select SIM(s) for Whitelisting.");
        setActionId(availableActions[0]?.value || "");
        return;
      }

      // ✅ 2. Check if any selected SIM is not ACTIVE
      const nonActiveSims = checkedItems.filter(
        (item) => item.simState?.toUpperCase() !== "ACTIVE",
      );

      if (nonActiveSims.length > 0) {
        alert(
          "Whitelisting can only be done for ACTIVE SIMs. Please activate the SIM(s) first.",
        );
        setActionId(availableActions[0]?.value || "");
        return;
      }

      // ✅ 3. Proceed with whitelisting
      setTempWhitelistIpGroup("");
      setTempWhitelistNumberGroup("");
      setShowWhitelistPopup(true);
    } else if (value === "Top_Up") {
      const checkedItems = currentFilteredData.filter((item) => item.checked);

      if (checkedItems.length === 0) {
        alert("Please select SIM(s) for Top Up.");
        setActionId(availableActions[0]?.value || "");
        return;
      }

     const nonActiveSims = checkedItems.filter((item) => {
  const simState = item.simState?.toUpperCase();

  return simState !== "ACTIVE" && simState !== "SAFECUSTODY";
});

if (nonActiveSims.length > 0) {
  alert(
    "Only ACTIVE SIMs can be Top Up. Please activate the SIM(s) first."
  );
  setActionId(availableActions[0]?.value || "");
  return;
}

      // Group items by account and filter only TopUp plans
      const grouped = checkedItems.reduce((acc, item) => {
        const accountName = item.account || "Unknown Account";

        // Check if this account has TopUp plans
        const accountPlans = accountDetails[accountName] || {};
        const hasTopUpPlans = Object.values(accountPlans).some(
          (plan) => plan.planType === "TopUp",
        );

        if (hasTopUpPlans) {
          if (!acc[accountName]) {
            acc[accountName] = [];
          }
          acc[accountName].push(item);
        }

        return acc;
      }, {});

      if (Object.keys(grouped).length === 0) {
        alert("No Top Up plans available for the selected SIM(s).");
        setActionId(availableActions[0]?.value || "");
        return;
      }

      setGroupedItemsToActivate(grouped);
      setShowTopup(true);
    } else if (value === "Renewal") {
      const checkedItems = currentFilteredData.filter((item) => item.checked);

      if (checkedItems.length === 0) {
        alert("Please select SIM(s) for Renewal.");
        setActionId(availableActions[0]?.value || "");
        return;
      }

      // 🔍 Check for non-active SIMs before proceeding
   const nonActiveSims = checkedItems.filter((item) => {
  const simState = item.simState?.toUpperCase();

  return simState !== "ACTIVE" && simState !== "SAFECUSTODY";
});

if (nonActiveSims.length > 0) {
  alert(
    "Only ACTIVE SIMs can be renewed. Please activate the SIM(s) first."
  );
  setActionId(availableActions[0]?.value || "");
  return;
}

      // ✅ Group items by account and filter only Renewal plans
      const grouped = checkedItems.reduce((acc, item) => {
        const accountName = item.account || "Unknown Account";

        // Check if this account has Renewal plans
        const accountPlans = accountDetails[accountName] || {};
        const hasRenewalPlans = Object.values(accountPlans).some(
          (plan) => plan.planType === "Renewel", // matches your spelling
        );

        if (hasRenewalPlans) {
          if (!acc[accountName]) {
            acc[accountName] = [];
          }
          acc[accountName].push(item);
        }

        return acc;
      }, {});

      if (Object.keys(grouped).length === 0) {
        alert("No Renewal plans available for the selected SIM(s).");
        setActionId(availableActions[0]?.value || "");
        return;
      }

      setGroupedItemsToActivate(grouped);
      setShowRenewal(true);
    } else if (value === "KYC") {
      handleOpenKycPopup();
    } else {
      setDeviceTypeValue("");
      setDeviceModelValue("");
    }
  };

  const grandTotal = Object.entries(groupedItemsToActivate).reduce(
    (acc, [accountName, items]) => {
      const selectedPlan = selectedPlans[accountName];
      const planCost = accountDetails[accountName]?.[selectedPlan]?.cost;
      const costValue = parseInt(planCost?.replace("₹", "")) || 0;
      return acc + costValue * items.length;
    },
    0,
  );

  const isChangeDeviceType = actionId === "change_device_type";
  const hasCheckedItems = currentFilteredData.some((item) => item.checked);

  const permissions = userPermissions()?.dashboardMenu?.simManagement?.edit;

  return (
    <>
      <DeviceTypePopup
        open={showDeviceTypePopup}
        onClose={handleCloseDeviceTypePopup}
        onConfirm={handleConfirmDeviceType}
        initialDeviceType={deviceTypeValue}
        tempDeviceTypeValue={tempDeviceTypeValue}
        setTempDeviceTypeValue={setTempDeviceTypeValue}
        tempDeviceModelValue={tempDeviceModelValue}
        setTempDeviceModelValue={setTempDeviceModelValue}
        deviceTypeValue={deviceTypeValue}
        deviceModelValue={deviceModelValue}
        handleCloseDeviceTypePopup={handleCloseDeviceTypePopup}
        handleConfirmDeviceType={handleConfirmDeviceType}
        setShowDeviceTypePopup={setShowDeviceTypePopup}
      />

      <AllocatePopup
        open={showAllocatePopup}
        onClose={handleCloseAllocatePopup}
        onConfirm={handleConfirmAllocate}
        tempAllocateToValue={tempAllocateToValue}
        setTempAllocateToValue={setTempAllocateToValue}
        allocateToValue={allocateToValue}
        handleCloseAllocatePopup={handleCloseAllocatePopup}
        handleConfirmAllocate={handleConfirmAllocate}
      />
      <WhitelistPopup
        open={showWhitelistPopup}
        onClose={() => setShowWhitelistPopup(false)}
        onConfirm={handleConfirmWhitelist}
        fetchDataWhitelistOptions={fetchDataWhitelistOptions}
        fetchSmsWhitelistOptions={fetchSmsWhitelistOptions}
        loadingDataWhitelistOptions={loadingDataWhitelistOptions}
        loadingSmsWhitelistOptions={loadingSmsWhitelistOptions}
        dataWhitelistOptions={dataWhitelistOptions}
        smsWhitelistOptions={smsWhitelistOptions}
        tempWhitelistIpGroup={tempWhitelistIpGroup}
        setTempWhitelistIpGroup={setTempWhitelistIpGroup}
        tempWhitelistNumberGroup={tempWhitelistNumberGroup}
        handleConfirmWhitelist={handleConfirmWhitelist}
        handleCloseWhitelistPopup={handleCloseWhitelistPopup}
        setTempWhitelistNumberGroup={setTempWhitelistNumberGroup}
        setIsWhitelistIpChecked={setIsWhitelistIpChecked}
        setIsWhitelistNumberChecked={setIsWhitelistNumberChecked}
        isWhitelistIpChecked={isWhitelistIpChecked}
        isWhitelistNumberChecked={isWhitelistNumberChecked}
        isActivationChecked={isActivationChecked}
      />

      <KYC_PopUp
        open={kycPopUp}
        onClose={closekyc}
        onConfirm={handleconfirmkyc}
        kycForm={kycForm}
        setKycForm={setKycForm}
      />
      {/* Plan Details Popup */}
      {showPlanDetailsPopup && (
        <PlanDetailsPopup
          open={showPlanDetailsPopup}
          onClose={handleClosePlanDetailsPopup}
          setLoadingDataWhitelistOptions={setLoadingDataWhitelistOptions}
          onApplyAction={onApplyAction}
          groupedItemsToActivate={groupedItemsToActivate}
          accountDetails={accountDetails}
          actionTargetField={actionTargetField}
          actionId={actionId}
          isWhitelistIpChecked={isWhitelistIpChecked}
          isWhitelistNumberChecked={isWhitelistNumberChecked}
          tempWhitelistIpGroup={tempWhitelistIpGroup}
          tempWhitelistNumberGroup={tempWhitelistNumberGroup}
          getDataRequestIdByName={getDataRequestIdByName}
          getSmsRequestIdByName={getSmsRequestIdByName}
          activateSimsWithWhitelisting={activateSimsWithWhitelisting}
          setIsWhitelistIpChecked={setIsWhitelistIpChecked}
          setIsWhitelistNumberChecked={setIsWhitelistNumberChecked}
          setTempWhitelistIpGroup={setTempWhitelistIpGroup}
          setTempWhitelistNumberGroup={setTempWhitelistNumberGroup}
          dataWhitelistOptions={dataWhitelistOptions}
          smsWhitelistOptions={smsWhitelistOptions}
          loadingDataWhitelistOptions={loadingDataWhitelistOptions}
          loadingSmsWhitelistOptions={loadingSmsWhitelistOptions}
          selectedPlans={selectedPlans}
          handlePlanToggle={handlePlanToggle}
          grandTotal={grandTotal}
          handleClosePlanDetailsPopup={handleClosePlanDetailsPopup}
          setGroupedItemsToActivate={setGroupedItemsToActivate}
          setShowPlanDetailsPopup={setShowPlanDetailsPopup}
          iskycChecked={isKycChecked}
          setIsKycChecked={setIsKycChecked}
          kycForm={kycForm}
          setKycForm={setKycForm}
        />
      )}
      {showTopup && (
        <Topup
          open={showTopup}
          onClose={closeTopup}
          onApplyAction={onApplyAction}
          groupedItemsToActivate={groupedItemsToActivate}
          accountDetails={accountDetails}
          actionTargetField={actionTargetField}
          actionId={actionId}
          isWhitelistIpChecked={isWhitelistIpChecked}
          isWhitelistNumberChecked={isWhitelistNumberChecked}
          tempWhitelistIpGroup={tempWhitelistIpGroup}
          tempWhitelistNumberGroup={tempWhitelistNumberGroup}
          getDataRequestIdByName={getDataRequestIdByName}
          getSmsRequestIdByName={getSmsRequestIdByName}
          activateSimsWithWhitelisting={activateSimsWithWhitelisting}
          setIsWhitelistIpChecked={setIsWhitelistIpChecked}
          setIsWhitelistNumberChecked={setIsWhitelistNumberChecked}
          setTempWhitelistIpGroup={setTempWhitelistIpGroup}
          setTempWhitelistNumberGroup={setTempWhitelistNumberGroup}
          dataWhitelistOptions={dataWhitelistOptions}
          smsWhitelistOptions={smsWhitelistOptions}
          loadingDataWhitelistOptions={loadingDataWhitelistOptions}
          loadingSmsWhitelistOptions={loadingSmsWhitelistOptions}
          selectedPlans={selectedPlans}
          handlePlanToggle={handlePlanToggle}
          grandTotal={grandTotal}
          // handleClosePlanDetailsPopup={handleClosePlanDetailsPopup}
          setGroupedItemsToActivate={setGroupedItemsToActivate}
          setShowPlanDetailsPopup={setShowTopup}
        />
      )}
      {showRenewal && (
        <Renewal
          open={showRenewal}
          onClose={closeRenewal}
          onApplyAction={onApplyAction}
          groupedItemsToActivate={groupedItemsToActivate}
          accountDetails={accountDetails}
          actionTargetField={actionTargetField}
          actionId={actionId}
          isWhitelistIpChecked={isWhitelistIpChecked}
          isWhitelistNumberChecked={isWhitelistNumberChecked}
          tempWhitelistIpGroup={tempWhitelistIpGroup}
          tempWhitelistNumberGroup={tempWhitelistNumberGroup}
          getDataRequestIdByName={getDataRequestIdByName}
          getSmsRequestIdByName={getSmsRequestIdByName}
          activateSimsWithWhitelisting={TopUP}
          setIsWhitelistIpChecked={setIsWhitelistIpChecked}
          setIsWhitelistNumberChecked={setIsWhitelistNumberChecked}
          setTempWhitelistIpGroup={setTempWhitelistIpGroup}
          setTempWhitelistNumberGroup={setTempWhitelistNumberGroup}
          dataWhitelistOptions={dataWhitelistOptions}
          smsWhitelistOptions={smsWhitelistOptions}
          loadingDataWhitelistOptions={loadingDataWhitelistOptions}
          loadingSmsWhitelistOptions={loadingSmsWhitelistOptions}
          selectedPlans={selectedPlans}
          handlePlanToggle={handlePlanToggle}
          grandTotal={grandTotal}
          handleClosePlanDetailsPopup={handleClosePlanDetailsPopup}
          setGroupedItemsToActivate={setGroupedItemsToActivate}
          setShowPlanDetailsPopup={setShowRenewal}
        />
      )}
      <Grid
        container
        spacing={2}
        alignItems="center"
        sx={{ marginTop: "-1rem", marginBottom: "0.5rem", marginLeft: "2rem" }}
      >
        <Grid item>
          <FormControl fullWidth size="small" sx={{ minWidth: 200 }}>
            <InputLabel id="field-select-label">Select Field</InputLabel>
            <Select
              labelId="field-select-label"
              label="Select Field"
              value={selectedField}
              onChange={(e) => {
                setSelectedField(e.target.value);
                setFrom("");
                setTo("");
              }}
            >
              {availableFields.map((field) => (
                <MenuItem key={field.value} value={field.value}>
                  {field.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item>
          <TextField
            size="small"
            label="From"
            value={from}
            onChange={(e) => {
              const inputValue = e.target.value;
              const filteredValue = inputValue.replace(/[^0-9]/g, "");
              setFrom(filteredValue);
            }}
            type="text"
          />
        </Grid>

        <Grid item>
          <TextField
            size="small"
            label="To"
            value={to}
            onChange={(e) => {
              const inputValue = e.target.value;
              const filteredValue = inputValue.replace(/[^0-9]/g, "");
              setTo(filteredValue);
            }}
            type="text"
          />
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            size="large"
            onClick={handleSearch}
            sx={{ backgroundColor: "var(--bg)" }}
          >
            Search
          </Button>
        </Grid>

        <Grid item>
          <FormControl fullWidth size="small" sx={{ minWidth: 200 }}>
            <InputLabel id="action-select-label">Select Action</InputLabel>
            <Select
              labelId="action-select-label"
              label="Select Action"
              value={actionId}
              onChange={handleActionChange}
            >
              {availableActions.map((action) => (
                <MenuItem key={action.value} value={action.value}>
                  {action.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            size="large"
            sx={{ backgroundColor: "var(--bg)" }}
            disabled={!hasCheckedItems || !permissions}
            onClick={handleApplyAction}
          >
            Apply Action
          </Button>
        </Grid>

        <Grid item>
          <Button
            variant="outlined"
            size="large"
            color="secondary"
            onClick={handleReset}
          >
            Reset
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default RangeActionFilter;
